<template>
    <div id="app" :class="background">
        <router-view></router-view>
        <dialog-host></dialog-host>
    </div>
</template>

<script>

// Import external libraries
import {
    mapActions,
    mapState
} from 'vuex';

import moment from 'moment';

import DialogHost from '@/core/components/DialogHost.vue';

// eslint-disable-next-line no-magic-numbers
const VERSION_REFRESH_TIMER_INTERVAL_MS = process.env.VUE_APP_VERSION_REFRESH_TIMER_INTERVAL_MS ?? 300000;

export default {
    name:       'app',
    components: { DialogHost },

    computed: {
        /**
         * Version state
         */
        ...mapState('core/version', ['version']),

        background () {
            return this.$router.currentRoute.name.includes('not-found') ? 'not-found-background' : 'coco-background';
        }
    },

    methods: {
        ...mapActions('core/version', ['getVersionFromJson', 'setVersionFromJson']),

        showRefreshDialog () {
            this.$dialog.alert({
                key:        'new-version',
                title:      this.$t('refresh-modal-title'),
                text:       `${this.$t('refresh-modal-body-1')} ${this.$t('refresh-modal-body-2')}`,
                centerText: true,
                image:      require('@/core/assets/images/massive-sent.png'),
                okText:     this.$t('refresh-modal-button'),
                blocking:   true,
                onConfirm:  async () => {
                    if (await this.setVersionFromJson()) {
                        window.location.reload();
                    }
                }
            });
        }
    },

    /**
     * Function to add link in the html head
     *
     * @return     {Object}
     */
    head () {
        let image = 'favicon.ico';
        if (process.env.VUE_APP_ENV === 'staging') {
            image = '/images/staging-badge.png';
        } else if (process.env.VUE_APP_ENV === 'local') {
            image = '/images/local-badge.png';
        }
        return {
            link: [{
                rel:  'icon', href: image, size: '32x32', type: 'image/png'
            }]
        };
    },

    /**
     * Before the component is created
     */
    beforeCreate () {
        /**
         * If the route has a specific locale, use it
         * Will get overridden by the User's locale, if logged in
         */
        if (this.$route.meta.locale !== 'undefined') {
            this.$i18n.locale = this.$route.meta.locale;
            moment.locale(this.$route.meta.locale);
        }
    },

    created () {
        // Set the version from the JSON file to the store
        this.setVersionFromJson().catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error while setting version', error);
        });

        // Refresh the version every REFRESH_TIMER_INTERVAL_MS milliseconds and compare it to the store version
        setInterval(() => {
            this.getVersionFromJson().then((version) => {
                // If the version from the JSON file is different from the store version, show the refresh modal and clear the interval
                if (version !== this.version) {
                    this.showRefreshDialog();
                    clearInterval(this.interval);
                }
            })
                .catch((error) => {
                    // eslint-disable-next-line no-console
                    console.error('Error while updating version', error);
                });
        }, VERSION_REFRESH_TIMER_INTERVAL_MS);
    }
};
</script>
